import React from 'react';
import './textarea.scss';


const Textarea = (props) => {
  
  return (
    <div className='text-area__main'>
      <label style={{color: 'black'}} htmlFor={props.id}>{props.label}</label>
      <textarea
      id={props.id}
      name={props.name}
      rows={props.rows || 3} 
      onChange={props.onChange}
      style={props.style}
      value={props.value}
      onClick={props.onClick}
      placeholder={props.placeholder}
      />
    </div>
  )
}


export default Textarea